export const staircaseConfig = {
    gameSlug: '3d-rotation',
    category: 'terre_navigation',
    variable: 'item_rank',
    startValue: 4,
    minValue: 1,
    maxValue: 12,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'down-easier',
};
/** Rang index → angle degrés (rang 1 = 15°, rang 12 = 180°). */
export function angleDegFromRank(rank) {
    const safe = Math.max(1, Math.min(12, Math.round(rank)));
    return safe * 15;
}
function buildVariant(level) {
    if (level <= 10) {
        return { level, responseTimeoutMs: 8000, label: 'Initiation rotation' };
    }
    if (level <= 20) {
        return { level, responseTimeoutMs: 6000, label: 'Vitesse rotation' };
    }
    if (level <= 30) {
        return { level, responseTimeoutMs: 5000, label: 'Standard MRT' };
    }
    if (level <= 40) {
        return { level, responseTimeoutMs: 4000, label: 'Pression temps' };
    }
    return { level, responseTimeoutMs: 3000, label: 'Limite Shepard-Metzler' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    fixationMs: 400,
    feedbackMs: 800,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: '3d-rotation',
    paradigm: 'Mental Rotation Task (Shepard & Metzler 1971)',
    masterMage: 'Garek (terre-navigation)',
    category: 'terre_navigation',
    goal: 'Cognition spatiale 3D : géométrie, ingénierie, chirurgie, sport.',
};
//# sourceMappingURL=params.js.map